<template>
<div class="container">
    <h2>Listado de Clientes</h2>
    <div class="text-left">
        <!--Modal ***********************-->
        <b-button variant="primary" v-b-modal.modal-1><i class="fas fa-plus-circle"></i> Cliente</b-button>
        <ModalAgregarCliente></ModalAgregarCliente>
        <!--Modal ***********************-->
    </div>
    <table class="table table-hover table-striped table-sm">
        <thead>
            <tr>
                <th>#</th>
                <th>Nombre</th>
                <th>Dirección</th>
                <th>Análisis</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(cliente, index) in traerDataClientes" :key="index">
                <td>{{index+1}}</td>
                <td>{{cliente.nombre}}<br /> <span class="text-info"> Tarifa: {{cliente.tarifa}}</span></td>
                <td>{{cliente.direccion | recorte}} <br /> <span class="text-info"> Estado: {{cliente.estado}}</span> <span><i class="fas fa-phone-volume mx-2"></i>{{ cliente.telefono}}</span> </td>
                <td>
                    <!--<b-button variant="outline-primary" v-b-tooltip.hover title="Editar cliente"><i class="far fa-edit"></i></b-button>-->
                    <b-button variant="outline-danger" v-b-tooltip.hover title="Análisis" @click="linkanalisis(index, cliente.idDoc)"><i class="far fa-chart-bar"></i></b-button>
                    <b-button variant="outline-warning" v-b-tooltip.hover title="Diagnóstico Tarifario AT4.3 o BT4.3" @click="diagnosticoTarifario(index, cliente.idDoc)" v-if="cliente.tarifa==='AT4.3' || cliente.tarifa === 'BT4.3'"><i class="far fa-lightbulb "></i></b-button>
                    <b-button variant="outline-warning" v-b-tooltip.hover title="Sólo tarifas AT4.3 o BT4.3" v-else><i class="far fa-lightbulb "></i></b-button>

                    <b-button variant="outline" v-b-tooltip.hover title="Edición Datos">
                        <ul class="navbar-nav">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="far fa-edit"></i>
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <button class="btn btn-light" data-placement="top" title="Editar Datos Cliente" data-toggle="modal" :data-target="'#editarDatosCliente'+index">Clientes</button>
                                    <button class="btn btn-light" data-placement="top" title="Editar Datos Distribuuidora" data-toggle="modal" :data-target="'#editarDatosDistribuidora'+index">Distribuidora</button>

                                    <button class="btn btn-light" data-placement="top" title="Editar Datos Consumo" data-toggle="modal" :data-target="'#editarDatosConsumoX43'+index" v-show="cliente.tarifa === 'AT4.3' || cliente.tarifa === 'BT4.3'">{{cliente.tarifa}}</button>
                                    <button class="btn btn-light" data-placement="top" title="Editar Datos Consumo" data-toggle="modal" :data-target="'#editarDatosConsumoX42'+index" v-show="cliente.tarifa === 'AT4.2' || cliente.tarifa === 'BT4.2'">{{cliente.tarifa}}</button>

                                    <button class="btn btn-light" data-placement="top" title="Editar Datos Consumo" data-toggle="modal" :data-target="'#editarDatosConsumoAT3'+index" v-show="cliente.tarifa === 'AT3' || cliente.tarifa === 'BT3'">{{cliente.tarifa}}</button>

                                    <a class="dropdown-item">Aporte</a>
                                </div>
                            </li>
                        </ul>
                    </b-button>
                    <b-button variant="outline-success" v-b-tooltip.hover title="La Propuesta de este cliente pasa a ser Proyecto" @click="convertiraProyecto(index, cliente.idDoc, cliente.estado)"><i class="far fa-images"></i></b-button>
                    <!--                    <b-button variant="outline-danger" v-b-tooltip.hover title="Enviar Email Banco" @click="sendEmail"><i class="fas fa-envelope-open-text"></i></b-button>-->

                    <!--Modal Modal Editar Datos Cliente-->
                    <ModalEditarDatosCliente :index='index'>
                    </ModalEditarDatosCliente>
                    <!--Modal Modal Editar Datos Cliente-->
                    <!--Modal Modal Editar Datos Distribuidora-->
                    <ModalEditarDatosDistribuidora :index='index'>
                    </ModalEditarDatosDistribuidora>
                    <!--Modal Modal Editar Datos Distribuidora-->
                    <!--Modal Modal Editar Datos Consumo  para tarifa AT4.3 o BT4.3-->
                    <ModalEditarConsumoX43 :index='index' v-show="cliente.tarifa === 'AT4.3' || cliente.tarifa === 'BT4.3'">
                    </ModalEditarConsumoX43>
                    <!--Modal Modal Editar Datos Consumo  para tarifa AT4.3 o BT4.3-->

                    <!--Modal Modal Editar Datos Consumo  para tarifa AT4.2 o BT4.2-->
                    <ModalEditarConsumoX42 :index='index' v-show="cliente.tarifa === 'AT4.2' || cliente.tarifa === 'BT4.2'">
                    </ModalEditarConsumoX42>
                    <!--Modal Modal Editar Datos Consumo  para tarifa AT4.2 o BT4.2-->
                    <!--Modal Modal Editar Datos Consumo  para tarifa AT4.1 o BT4.1-->
                    <ModalEditarConsumoX41 :index='index' v-show="cliente.tarifa === 'AT4.1' || cliente.tarifa === 'BT4.1'">
                    </ModalEditarConsumoX41>
                    <!--Modal Modal Editar Datos Consumo  para tarifa AT4.1 o BT4.1-->
                    <!--Modal Modal Editar Datos Consumo  para tarifa AT3 o BT3-->
                    <ModalEditarConsumoAT3 :index='index' v-show="cliente.tarifa === 'AT3' || cliente.tarifa === 'BT3'">
                    </ModalEditarConsumoAT3>
                    <!--Modal Modal Editar Datos Consumo  para tarifa AT3 o BT3-->
                    <!--Modal Modal Editar Datos Consumo  para tarifa AT2 o BT2-->
                    <ModalEditarConsumoAT2 :index='index' v-show="cliente.tarifa === 'AT2' || cliente.tarifa === 'BT2'">
                    </ModalEditarConsumoAT2>
                    <!--Modal Modal Editar Datos Consumo  para tarifa AT2 o BT2-->
                    <!--Modal Modal Editar Datos Consumo  para tarifa BT1B-->
                    <ModalEditarConsumoBT1B :index='index' v-show="cliente.tarifa === 'BT1B'">
                    </ModalEditarConsumoBT1B>
                    <!--Modal Modal Editar Datos Consumo  para tarifa BT1B-->
                    <!--Modal Modal Editar Datos Consumo  para tarifa BT1A-->
                    <ModalEditarConsumoBT1A :index='index' v-show="cliente.tarifa === 'BT1A'">
                    </ModalEditarConsumoBT1A>
                    <!--Modal Modal Editar Datos Consumo  para tarifa BT1A-->

                </td>
            </tr>
        </tbody>
    </table>

</div>
</template>

<script>
import ModalAgregarCliente from '../components/ModalAgregarCliente.vue';
import ModalEditarDatosCliente from '../components/ModalEditarDatosCliente.vue';
import ModalEditarDatosDistribuidora from '../components/ModalEditarDatosDistribuidora';
import ModalEditarConsumoX43 from '../components/ModalEditarConsumoX43.vue';
import ModalEditarConsumoX42 from '../components/ModalEditarConsumoX42.vue';
import ModalEditarConsumoX41 from '../components/ModalEditarConsumoX41.vue';
import ModalEditarConsumoAT3 from '../components/ModalEditarConsumoAT3.vue';
import ModalEditarConsumoAT2 from '../components/ModalEditarConsumoAT2.vue';
import ModalEditarConsumoBT1B from '../components/ModalEditarConsumoBT1B.vue';
import ModalEditarConsumoBT1A from '../components/ModalEditarConsumoBT1A.vue';
import Swal from 'sweetalert2';

export default {
    name: 'Home',
    components: {
        ModalAgregarCliente,
        ModalEditarDatosCliente,
        ModalEditarDatosDistribuidora,
        ModalEditarConsumoX43,
        ModalEditarConsumoX42,
        ModalEditarConsumoX41,
        ModalEditarConsumoAT3,
        ModalEditarConsumoAT2,
        ModalEditarConsumoBT1B,
        ModalEditarConsumoBT1A,
    },
    data() {
        return {
            cantidadanalisis: 0
        }
    },
    computed: {
        traerDataClientes() {
            return this.$store.getters.enviarDataClientes;
        }
    },
    methods: {
        linkanalisis(index, idDoc) {
            this.$store.dispatch('llamarAnalisis', idDoc)
            this.$router.push(`/listadoanalisis/${index}`)
        },
        diagnosticoTarifario(index) {
            //console.log(index);
            //console.log(idDoc);
            this.$store.state.DiagnosticoTarifarioX43 = 0;
            this.$store.state.DiagnosticoTarifarioX42 = 0;
            this.$store.state.DiagnosticoTarifarioX41 = 0;
            this.$store.state.DiagnosticoTarifarioX3 = 0;
            this.$store.state.DiagnosticoTarifarioX2 = 0;
            this.$router.push(`/diagnostico/${index}`);
        },
        editarDatoscliente(index) {
            alert(index);
        },
        convertiraProyecto(index, idDoc, estado) {
            if (estado === 'Propuesta') {
                Swal.fire({
                    title: 'Pasar esta Propuesta Comercial a Proyecto?',
                    text: "Para hacerle seguimiento",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, Proyecto para ECER'
                }).then((result) => {
                    if (result.isConfirmed) {

                        this.$store.dispatch('convertiraProyecto', idDoc)
                    }
                })
            } else {
                Swal.fire("Este cliente ya es un Proyecto para ECER")
            }
        },
        sendEmail() {
            this.$router.push('sendemail');
        }
    }
}
</script>
